import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../translations';

export const PurchaseInvoiceAmountOnGrid = (props: { paid: boolean }) => {
  const { t, tk } = useTranslation('fvzLng');
  return (
    <>
      {props.paid && (
        <>
          <OverlayTrigger
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {t(tk.invoice.paid)}
              </Tooltip>
            }
          >
            <Icon.CircleFill className="icon-green me-2" />
          </OverlayTrigger>
          {t(tk.common.yes)}
        </>
      )}
    </>
  );
};
